import { Queue, QueueCondition, TaskManagementService } from 'src/app/services/api/taskmanagement/taskmanagement.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { QueueConditionField } from 'src/app/models/taskmanagement/queue-condition-field.enum'
import { QueueConditionOperation } from 'src/app/models/taskmanagement/queue-condition-operation.enum'
import { QueueConditionObject } from 'src/app/models/taskmanagement/queue-condition-object.model'
import { QueueObject } from 'src/app/models/taskmanagement/queue-object.model'

@Component({
  selector: 'app-update-queue',
  templateUrl: './update-queue.component.html',
  styleUrls: ['./update-queue.component.scss']
})

export class UpdateQueueComponent implements OnInit {

  queue:Queue;
  queueConditions: QueueCondition[];
  form: FormGroup;

  tooltip = {
    submit: '',
    reset: '',
    addCondition: ''
  };

  queueFieldDomainOptions:Array<string>=["MOBILE","FTTH","TV"];
  queueFieldTaskType: Array<string> = ["TechnicalError","SCAIError"]
  queueConditionsFieldOptions: any[] = [];
  queueConditionsOperationOptions: any[] = [];

  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private notificationsService: NotificationsService,
    private taskmanagementService:TaskManagementService,
    public dialogRef: MatDialogRef<UpdateQueueComponent>,
     @Inject(MAT_DIALOG_DATA) private data: {
    queue: Queue;
  },) { }

  get queueNameForm(){
    return this.form.get('queueName');
  }
  get queueDescForm(){
    return this.form.get('queueDesc');
  }
  get queueRoleForm(){
    return this.form.get('queueRol');
  }
  get queuePriorityForm(){
    return this.form.get('queuePriority');
  }
  get queueConditionsForm(){
    return this.form.get('queueConditionsForm') as FormArray;
  }


  ngOnInit() {
    this.queue = this.data.queue
    this.queueConditions = this.queue.conditions
    for (let item in QueueConditionField) {
      if (isNaN(Number(item))) {
        this.queueConditionsFieldOptions.push({ text: item, value: QueueConditionField[item] });
      }
    }
    for (let item in QueueConditionOperation) {
      if (isNaN(Number(item))) {
        this.queueConditionsOperationOptions.push({ text: item, value: QueueConditionOperation[item] });
      }
    }

    this.initForm();
    this.initTooltips();
  }

  initForm(){
    this.form = this.formBuilder.group({
      queueName: this.formBuilder.control({value:this.queue.name,disabled: true},Validators.required),
      queueDesc: this.formBuilder.control({value:this.queue.description,disabled:false},Validators.required),
      queueRol: this.formBuilder.control({value: this.queue.role,disabled: false},Validators.required),
      queuePriority: this.formBuilder.control({value: this.queue.priority, disabled: false}, [Validators.required, Validators.min(1), Validators.max(999)]),
      queueConditionsForm: this.formBuilder.array([])
    });
    for (let condition of this.queueConditions){
      this.addQueueConditionWithValues(condition.queueConditionId,condition.field,condition.operation,condition.value);
    }
  }


  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
      this.tooltip.reset = this.translate.instant('TOOLTIPS.resetForm');
      this.tooltip.addCondition = this.translate.instant('TOOLTIPS.addQueueCondition');
    });
  }

  clearForm() {
    this.form.reset();
    this.initForm();
  }


  public submitForm() {
    if(this.validateForm()){
      const queueUpdated:Queue = new QueueObject();
      queueUpdated.queueId = this.queue.queueId;
      queueUpdated.name = this.form.get('queueName').value;
      queueUpdated.description = this.form.get('queueDesc').value;
      queueUpdated.role = this.form.get('queueRol').value;
      queueUpdated.priority = this.form.get('queuePriority').value;
      let queueConditionsUpdated: QueueCondition[]=[];
      for(let item of this.queueConditionsForm.controls){
        const conditionUpdated:QueueCondition = new QueueConditionObject();
        conditionUpdated.queueConditionId = item.get("queueConditionId").value;
        conditionUpdated.field = item.get("field").value;
        conditionUpdated.operation = item.get("operation").value;
        conditionUpdated.value = item.get("value").value;
        queueConditionsUpdated.push(conditionUpdated);
      }
      queueUpdated.conditions = queueConditionsUpdated;
      this.taskmanagementService.updateQueue(queueUpdated).subscribe(() =>
      {
        this.notificationsService.showNotification(`La cola ${this.queue.name} se ha actualizado correctamente`, NotificationLevel.SUCCESS);
        this.dialogRef.close();
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al actualizar la Cola:\n${error.error.errorDesc.stackTrace}`, NotificationLevel.ERROR);
      });
    }
  }

  validateForm() : boolean{
    for(let item of this.queueConditionsForm.controls){
      if(item.get("field").value == QueueConditionField.Dominio){

        if(this.queueFieldDomainOptions.find((element) => element === item.get("value").value) == undefined){
          this.notificationsService.showNotification(`El valor ${item.get("value").value} no está permitido para el campo Domino. Valores válidos: ${this.queueFieldDomainOptions}`, NotificationLevel.ERROR);
          return false;
        }
      }
      if(item.get("field").value == QueueConditionField['Tipo de tarea']){

        if(this.queueFieldTaskType.find((element) => element === item.get("value").value) == undefined){
          this.notificationsService.showNotification(`El valor ${item.get("value").value} no está permitido para el campo Tipo de tarea. Valores válidos: ${this.queueFieldTaskType} `, NotificationLevel.ERROR);
          return false;
        }
      }
    }
    return true;
  }

  addQueueConditionWithValues(queueConditionId: string, field: string, operation: string, value: string){
    const queueConditionFormGroup  = this.formBuilder.group({
      queueConditionId: queueConditionId,
      field: this.formBuilder.control({value:field,disabled: false},Validators.required),
      operation: this.formBuilder.control({value:operation,disabled: false},Validators.required),
      value: this.formBuilder.control({value:value,disabled: false},Validators.required),
    });
    this.queueConditionsForm.push(queueConditionFormGroup);
  }

  addQueueCondition(){
    const queueConditionFormGroup  = this.formBuilder.group({
      queueConditionId: '',
      field: '',
      operation: '',
      value: ''
    });
    this.queueConditionsForm.push(queueConditionFormGroup);
  }

  removeQueueCondition(indice: number) {
    this.queueConditionsForm.removeAt(indice);
  }

}
